export function isIosSafariNonStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isIos = /iPad|iPhone|iPod/.test(ua);
  if (!isIos) return false;
  const isStandaloneMatchMedia = window.matchMedia('(display-mode: standalone)').matches;
  const isStandaloneLegacy =
    'standalone' in navigator &&
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return !isStandaloneMatchMedia && !isStandaloneLegacy;
}

export function supportsPushNotifications(): boolean {
  if (typeof window === 'undefined') return false;
  return 'Notification' in window && 'serviceWorker' in navigator;
}

// Detect Homescreen-PWA / installed-app launch context across iOS and
// the rest. iOS uses the legacy `navigator.standalone` boolean; Android +
// Desktop expose `display-mode: standalone` via matchMedia.
export function isPwaStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const isStandaloneMatchMedia = window.matchMedia('(display-mode: standalone)').matches;
  const isStandaloneLegacy =
    'standalone' in navigator &&
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return isStandaloneMatchMedia || isStandaloneLegacy;
}
